import BaseClient from './client';

export const PluginSettingsPath = Object.freeze({
  SHORTCUTS: 'doctor/plugin-settings/shortcuts',
});

/**
 * Settings of the consultation plugins, kept on the server per doctor. Shortcuts resolve with
 * `{ pluginIds, saved }` (`saved` is false until the doctor first saves them).
 */
export class PluginSettingsService extends BaseClient {
  async fetchShortcuts(options = {}) {
    const response = await this.get(PluginSettingsPath.SHORTCUTS, options);
    return response.unwrap().data;
  }

  async saveShortcuts(pluginIds) {
    const response = await this.put(PluginSettingsPath.SHORTCUTS, { plugin_ids: pluginIds });
    return response.unwrap().data;
  }
}

export const pluginSettingsService = new PluginSettingsService();

export default PluginSettingsService;
